import { IOrganisationRoleInterface, TUserRoles } from '@enums/common';

export const getRoleAvailabilityByOrganisationType = ({
	roleAvailability,
	organisationRoles,
}: {
	roleAvailability: TUserRoles[];
	organisationRoles: IOrganisationRoleInterface[];
}): TUserRoles[] => {
	return roleAvailability.filter(role => {
		return organisationRoles.reduce<TUserRoles[]>((acc, category) => {
			const listOfRolesInCategory = category.roles.map(({ name }) => name);

			return [...acc, ...listOfRolesInCategory];
		}, [])
			.includes(role);
	});
};
